import { createAsyncThunk } from '@reduxjs/toolkit';
import { postCreateAndUpdateFirestopDetailAndProductItems } from '../services/post-create-and-update-firestop-detail-and-product-items.service';

export const saveCreatedAndUpdatedFirestopDetailAndProductItems =
  createAsyncThunk(
    'firestopDocumentation/saveCreatedAndUpdatedFirestopDetailAndProductItems',
    async ({
      projectId,
      createdFirestopDetails,
      updatedFirestopDetails,
      createdFirestopProducts,
      updatedFirestopProducts,
      createdFirestopDetailImages = [],
      deletedFirestopDetailImages = [],
    }) => {
      const response = await postCreateAndUpdateFirestopDetailAndProductItems(
        projectId,
        {
          firestopDetailsToCreate: createdFirestopDetails,
          firestopDetailsToUpdate: updatedFirestopDetails,
          firestopProductsToCreate: createdFirestopProducts,
          firestopProductsToUpdate: updatedFirestopProducts,
          firestopDetailImagesToCreate: createdFirestopDetailImages,
          firestopDetailImagesToDelete: deletedFirestopDetailImages,
        }
      );

      return response;
    }
  );
